import { Suspense } from 'react';
import {
  VenueGeneralInformation,
  VenueOperator,
  VenueOperatorContactPersons,
} from '@features';
import { Grid, Skeleton, Stack } from '@mantine/core';

const COL_SPAN = { base: 12, md: 6 };
const SKELETON_MIN_HEIGHT = 100;

export const VenueDetailsGeneralPage: React.FC = () => {
  return (
    <Stack py="md">
      <Grid>
        <Grid.Col span={COL_SPAN}>
          <Suspense fallback={<Skeleton mih={SKELETON_MIN_HEIGHT} />}>
            <VenueGeneralInformation />
          </Suspense>
        </Grid.Col>

        <Grid.Col span={COL_SPAN}>
          <Stack>
            <Suspense fallback={<Skeleton mih={SKELETON_MIN_HEIGHT} />}>
              <VenueOperator />
            </Suspense>
            <Suspense fallback={<Skeleton mih={SKELETON_MIN_HEIGHT} />}>
              <VenueOperatorContactPersons />
            </Suspense>
          </Stack>
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
